import React, { Component } from 'react';
import { Col, Label } from "reactstrap";
import Select from 'react-select';
import { montarSelectOption, setTemaSeletor } from "../../../utils/formatar";
import { inject, observer } from "mobx-react/index";

@inject("store")
@observer
export default class SelectFiltro extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Col 
                className={`${this.props.className ? this.props.className : 'mb-4'}`}
                xs={this.props.xs || 'auto'}
                sm={this.props.sm || 'auto'}
                md={this.props.md || 'auto'}
                lg={this.props.lg || 'auto'}
                xl={this.props.xl || 'auto'}
            >
                <div className="w-100">
                    {this.props.titulo && <Col xs={12} className={`${this.props.tituloClass ? this.props.tituloClass : 
                                                                    this.props.className ? this.props.className : 'col-label px-0'}`} >
                        <Label>{this.props.titulo}</Label>
                    </Col>}

                    <Col xs={12} className="px-0">
                        <Select
                            placeholder={this.props.placeholder || "Selecione"}
                            className={`w-100 select-filtro ${this.props.className ? this.props.className : ""}`}
                            isDisabled={this.props.bloqueado}
                            isClearable={this.props.naoLimpar ? !this.props.naoLimpar : true}
                            isSearchable={true}
                            theme={theme => setTemaSeletor(theme)}
                            value={this.props.valor}
                            onChange={this.props.onChange}
                            noOptionsMessage={() => ("Não há opções")}
                            options={this.props.options ? this.props.options : montarSelectOption(this.props.itensValor, this.props.itensLabel, this.props.itens)}
                        />
                    </Col>
                    {this.props.alertaObrigatorio &&
                        <Col xs={12} className="col-label label-obrigatorio px-0">
                            <Label>Esse campo é obrigatório</Label>
                        </Col>
                    }

                </div>
            </Col>
        )
    }

}



// WEBPACK FOOTER //
// ./src/modules/comum/components/SelectFiltro.js